import { errors } from "@ryde/shared";

/** The only `?error=` values the backend redirects to the login page with. */
export const LOGIN_REDIRECT_ERROR_KEYS: readonly string[] = [
  errors.common.authenticationError,
  errors.common.unknownError,
];

/** Motion tokens for the login screen (title line, OR divider, form entrance). */

export const LOGIN_PAGE_MOTION = {
  lineRevealDurationMs: 1600,
  lineRevealDelayMs: 280,
  lineRevealEasing: "cubic-bezier(0.22, 0.61, 0.36, 1)",
  formRevealDurationMs: 880,
  formRevealDelayMs: 120,
  formRevealEasing: "cubic-bezier(0.22, 0.61, 0.36, 1)",
} as const;
